<template>
  <div class="container-wide mt-5">
    <div class="d-flex flex-column flex-sm-row justify-content-sm-between mb-3">
      <div>
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Manage Branches
        </div>
        <div class="d-flex align-items-center w-100 cursor-pointer">
          <span class="mr-1 text-white">
            <VideoPlayIcon />
          </span>
          <span class="s-13 text-dak font-weight-600">
            <u>
              {{
                navigatorLang === "en-US"
                  ? "Watch Video"
                  : $t("people.watchVideo")
              }}
            </u>
          </span>
        </div>
      </div>
      <div class="d-flex flex-column flex-sm-row mt-2 my-1 mb-3">
        <div>
          <el-dropdown
            trigger="click"
            class="align-items-center justify-content-center d-flex ml-md-3 ml-0 default-btn2 py-0 mr-2"
            style="height: 2.2rem"
          >
            <span
              class="el-dropdown-link w-100 primary--text text-center font-weight-600"
            >
              More
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <!-- <el-dropdown-item class="text-black"
                  ><router-link
                    class="text-dak text-decoration-none"
                    to="/tenant/people/add"
                    >Add Member</router-link
                  >
                </el-dropdown-item>
                <el-dropdown-item class="text-black">
                  <router-link
                    class="text-dak text-decoration-none cursor-pointer"
                    to="/tenant/people/addfirsttimer"
                    >Add First Timer</router-link
                  >
                </el-dropdown-item>
                <el-dropdown-item class="text-black">
                  <div @click="sendMarkedMemberSms">Send Sms</div>
                </el-dropdown-item>
                <el-dropdown-item
                  class="text-black"
                  @click="sendMarkedBranchEmail"
                >
                  Send Email
                </el-dropdown-item>
                <el-dropdown-item
                  class="text-black"
                  @click="displayWhatsappDrawer"
                >
                  Send Whatsapp
                </el-dropdown-item> -->
                <el-dropdown-item class="text-black w-100">
                  <router-link
                    class="text-black text-decoration-none w-100"
                    to="/tenant/branch/hierarchicalbranch"
                  >
                    View Hierarchy
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item class="text-black w-100">
                  <router-link
                    class="text-black text-decoration-none w-100"
                    to="/tenant/branch/branches"
                  >
                    Branches
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item class="text-black w-100">
                  <router-link
                    class="text-black text-decoration-none w-100"
                    to="/tenant/branch/branchremittance"
                  >
                    Remittances
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item class="text-black w-100">
                  <div
                    class="text-dak cursor-pointer w-100"
                    @click="routeToReport"
                  >
                    <div class="d-flex justify-content-between w-100">
                      <span>View Reports </span>
                      <!-- <span
                        ><img style="height: 1.5rem" :src="AnalysicIcon" alt=""
                      /></span> -->
                    </div>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <div class="c-pointer">
          <el-button
            round
            class="w-100 mt-sm-0 mt-3"
            @click="showModal"
            :color="primarycolor"
          >
            Add Branch
          </el-button>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="row justify-content-between">
          <div class="col-md-6">
            <el-tree-select
              v-model="selectedTree"
              class="w-100"
              placeholder="Select branch"
              :data="branchMappedTree"
              :render-after-expand="false"
              :filter-node-method="filterNodeMethod"
              @change="setBranchValue"
              filterable
              check-strictly
            />
          </div>
          <div class="col-md-4 col-12 mt-4 mt-md-0 d-flex justify-content-end">
            <div class="col-md-11 d-flex justify-content-end">
              <div class="mr-3">
                <el-date-picker
                  v-model="startDate"
                  type="date"
                  size="large"
                  placeholder="From"
                  class="w-100"
                  format="MM/DD/YYYY"
                />
              </div>
              <div>
                <el-date-picker
                  v-model="endDate"
                  type="date"
                  placeholder="To"
                  size="large"
                  class="w-100"
                  format="MM/DD/YYYY"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Top Summary -->
    <div class="row mt-4">
      <div class="col-md-3 mb-4">
        <div
          class="card border-radius-15 bg-gray-500 border-no-radius h-100 pb-2 px-3 pt-1"
          v-loading="loading"
        >
          <div class="card-icon d-flex justify-content-between my-2">
            <img :src="BranchIcon" style="height: 3rem" alt="" />
            <div class="mb-1">
              <span class="card-text">Total People</span>
              <h5 class="card-title text-right font-weight-600">
                {{ getTotalPeopleBch.toLocaleString() }}
              </h5>
            </div>
          </div>
          <div class="card-content mt-3">
            <div class="mb-2">
              <span class="card-text">Total Branches</span>
              <h5 class="card-title font-weight-600">
                {{ allBranchDetail.length.toLocaleString() }}
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div
          class="card border-radius-15 bg-gray-500 border-no-radius h-100 pb-2 px-3 pt-1"
          v-loading="loading"
        >
          <div class="card-icon my-2">
            <img :src="WalkIcon" style="height: 3rem" alt="" />
          </div>
          <div class="card-content mt-3">
            <div class="mb-2">
              <span class="card-text">Average Attendance</span>
              <h5 class="card-title s-24 font-weight-600">
                {{ Math.round(getTotalAverageAttendance).toLocaleString() }}
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div
          class="card border-radius-15 bg-gray-500 border-no-radius h-100 pb-2 px-3 pt-1"
          v-loading="loading"
        >
          <div class="card-icon d-flex justify-content-between my-2">
            <img :src="ArrowDown" class="inflow" style="height: 3rem" alt="" />
            <div class="text-right">
              <div class="s-15">Current year inflow</div>
              <div class="font-weight-600 s-15">
                {{
                  allBranchDetail &&
                  allBranchDetail[0] &&
                  allBranchDetail[0].currency
                    ? allBranchDetail[0].currency.shortCode
                    : ""
                }}
                {{ Math.round(getCurrentYearInflow).toLocaleString() }}
              </div>
            </div>
          </div>
          <div class="card-content d-flex justify-content-between mt-3">
            <div class="mb-2">
              <span class="card-text">{{ currentMonth }} Inflow</span>
              <h5 class="card-title s-24 font-weight-600">
                {{
                  allBranchDetail &&
                  allBranchDetail[0] &&
                  allBranchDetail[0].currency
                    ? allBranchDetail[0].currency.shortCode
                    : ""
                }}
                {{ Math.round(getTotalMonthlyInflow).toLocaleString() }}
              </h5>
            </div>
            <span class="text-success d-flex align-items-center">
              <span>+{{ Math.round(incomePercentage) }}%</span>
              <el-icon class="text-success" :size="25"><Top /></el-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div
          class="card border-radius-15 bg-gray-500 border-no-radius h-100 pb-2 px-3 pt-1"
          v-loading="loading"
        >
          <div class="card-icon d-flex justify-content-between my-2">
            <img :src="ArrowUp" class="outflow" style="height: 3rem" alt="" />
            <div class="text-right">
              <div class="s-15">Current year Outflow</div>
              <div class="font-weight-600 s-15">
                {{
                  allBranchDetail &&
                  allBranchDetail[0] &&
                  allBranchDetail[0].currency
                    ? allBranchDetail[0].currency.shortCode
                    : ""
                }}{{ Math.round(getCurrentYearOutflow).toLocaleString() }}
              </div>
            </div>
          </div>
          <div class="card-content d-flex justify-content-between mt-3">
            <div class="mb-1">
              <span class="card-text"> {{ currentMonth }} Outflow</span>
              <h5 class="card-title s-24 font-weight-600">
                {{
                  allBranchDetail &&
                  allBranchDetail[0] &&
                  allBranchDetail[0].currency
                    ? allBranchDetail[0].currency.shortCode
                    : ""
                }}
                {{ Math.round(getTotalMonthlyOutflow).toLocaleString() }}
              </h5>
            </div>
            <span class="text-danger d-flex align-items-center"
              ><span>+{{ Math.round(expensePercentage) }}%</span
              ><el-icon class="text-danger" :size="25"><Top /></el-icon
            ></span>
          </div>
        </div>
      </div>
    </div>
    <!-- Branch Data Overview -->

    <div
      v-if="loading"
      class="d-flex flex-column flex-md-row justify-content-md-center"
    >
      <el-icon class="is-loading" :size="30">
        <Loading />
      </el-icon>
    </div>
    <div
      v-if="allBranchDetail && allBranchDetail.length > 0"
      class="container-fluid"
    >
      <div class="row">
        <div class="col-md-12 mb-4 px-0 d-flex justify-content-end">
          <div
            v-for="(branch, index) in hierarchesData"
            :key="index"
            class="s-15 font-weight-bold text-dak mr-2"
          >
            {{ branch.name }} : {{ branch.count }}
            <span v-if="index !== hierarchesData.length - 1"> | </span>
          </div>
        </div>
        <div class="col-md-12 px-0">
          <div class="row pt-4">
            <div class="col-md-12 mb-3 px-0 d-flex justify-content-md-end">
              <div class="">
                <div class="col-md-12 mt-sm-0 mt-3 d-flex">
                  <div class="col-md-7 col-12">
                    <el-dropdown
                      trigger="click"
                      class="align-items-center justify-sm-content-center border-radius-60 d-flex ml-md-3 ml-0 bg-gray-600 py-0 mr-2"
                      style="height: 2.8rem"
                    >
                      <span class="el-dropdown-link w-100 text-center fw-400">
                        Filter
                        <el-icon class="el-icon--right">
                          <arrow-down />
                        </el-icon>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu
                          @command="(command) => (sortOption.value = command)"
                        >
                          <el-dropdown-item
                            command="Branch Name"
                            class="text-black"
                            >Branch Name</el-dropdown-item
                          >
                          <el-dropdown-item
                            command="Membership size"
                            class="text-black"
                            >Membership Size</el-dropdown-item
                          >
                          <el-dropdown-item
                            command="Attendance"
                            class="text-black"
                            >Attendance</el-dropdown-item
                          >
                          <el-dropdown-item command="Income" class="text-black"
                            >Income</el-dropdown-item
                          >
                          <el-dropdown-item command="Expense" class="text-black"
                            >Expense</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </div>
                  <el-input
                    class="w-100 rounded-border"
                    :prefix-icon="Search"
                    placeholder="Search"
                    v-model="searchText"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-12 mt-2 px-0"
          :class="{
            branchesHeight: allBranchDetail && allBranchDetail.length > 0,
          }"
        >
          <div
            v-for="(branches, parentGroup) in filteredGroups"
            :key="parentGroup"
            class="mb-4"
          >
            <div
              class="bg-gray-500 text-dak border-radius-8 px-3 py-2 font-weight-bold"
            >
              {{ parentGroup }}
            </div>
            <CustomTable
              :data="branches"
              :headers="branchHeaders"
              :checkMultipleItem="false"
            >
              <template v-slot:name="{ item }">
                <div class="c-pointer fw-500" @click="viewBranch(item)">
                  <div>{{ item.name }}</div>
                </div>
              </template>
              <template v-slot:membershipSize="{ item }">
                <div class="c-pointer" @click="viewBranch(item)">
                  {{ item.membershipSize.toLocaleString() }}
                </div>
              </template>
              <template v-slot:currentYearAverageAttendance="{ item }">
                <div class="c-pointer" @click="viewBranch(item)">
                  {{
                    Math.abs(item.currentYearAverageAttendance).toLocaleString()
                  }}
                </div>
              </template>
              <template v-slot:currentYearIncome="{ item }">
                <div class="c-pointer" @click="viewBranch(item)">
                  {{
                    item.currency && item.currency.shortCode
                      ? item.currency.shortCode
                      : ""
                  }}
                  {{ Math.abs(item.currentYearIncome).toLocaleString() }}
                </div>
              </template>
              <template v-slot:currentYearExpense="{ item }">
                <div class="c-pointer" @click="viewBranch(item)">
                  {{
                    item.currency && item.currency.shortCode
                      ? item.currency.shortCode
                      : ""
                  }}
                  {{ Math.abs(item.currentYearExpense).toLocaleString() }}
                </div>
              </template>
            </CustomTable>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="adjust-view mt-4 col-md-12 d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <span class="mr-3"
              ><img
                style="height: 47px; width: 47px"
                src="../../assets/PersonWalked.png"
                alt=""
            /></span>
            <span class="text-dak font-weight-600 s-24"
              >Income vs Expense
            </span>
          </div>
          <div class="py-2 pl-4 primary--text s-15 bg-gray-500 fw-500">
            <el-dropdown trigger="click" class="w-100">
              <span class="el-dropdown-link w-100">
                <div
                  class="d-flex justify-content-between primary--text w-100"
                  size="large"
                >
                  <span class="my-2"
                    >Sort By
                    {{
                      selectedWeekly && selectedWeekly.name
                        ? selectedWeekly.name
                        : selectedWeekly
                    }}</span
                  >
                  <div class="bg-white d-flex py-1 my-1">
                    <el-icon class="el-icon--right">
                      <arrow-down />
                    </el-icon>
                  </div>
                </div>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    v-for="(itm, indx) in chartItemdropdown"
                    :key="indx"
                    @click="selectedType2(itm)"
                    >{{ itm.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
        <div class="col-md-12 d-flex mt-3">
          <div
            v-for="(item, index) in hierarchesData"
            :key="item.id"
            class="s-16 fw-400 text-dak mr-2"
            :class="{
              'active-branch': activeIncomeExpenseHierarchyId === item.id,
            }"
            @click="getIncomeExpenseByHierarchy(item)"
            style="cursor: pointer"
          >
            {{ item.name }}
            <span v-if="index !== hierarchesData.length - 1"> &gt; </span>
          </div>
        </div>
        <div class="col-md-12 mt-4">
          <ColumnChart
            :series="incomeExpenseSeries"
            :data="incomeExpenseCharrt"
            header=""
            domId="chart"
            title=""
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="adjust-vi col-md-12 d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <span class="mr-3"
              ><img
                style="height: 47px; width: 47px"
                src="../../assets/PersonWalked.png"
                alt=""
            /></span>
            <span class="text-dak font-weight-600 s-24">Membership </span>
          </div>
          <div class="py-2 pl-4 primary--text s-15 bg-gray-500 fw-500">
            <el-dropdown trigger="click" class="w-100">
              <span class="el-dropdown-link w-100">
                <div
                  class="d-flex justify-content-between primary--text w-100"
                  size="large"
                >
                  <span class="my-2"
                    >Sort By
                    {{
                      selectedWeekly && selectedWeekly.name
                        ? selectedWeekly.name
                        : selectedWeekly
                    }}</span
                  >
                  <div class="bg-white d-flex py-1 my-1">
                    <el-icon class="el-icon--right">
                      <arrow-down />
                    </el-icon>
                  </div>
                </div>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    v-for="(itm, indx) in chartItemdropdown"
                    :key="indx"
                    @click="selectedType2(itm)"
                    >{{ itm.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
        <div class="col-md-12 d-flex mt-3">
          <div
            v-for="(item, index) in hierarchesData"
            :key="item.id"
            class="s-16 fw-400 text-dak mr-2"
            :class="{ 'active-branch': activeMemberHierachyId === item.id }"
            @click="getMembersByHierarchy(item)"
            style="cursor: pointer"
          >
            {{ item.name }}
            <span v-if="index !== hierarchesData.length - 1"> &gt; </span>
          </div>
        </div>

        <div class="col-md-12 mt-4">
          <ColumnChart
            :series="memberSeries"
            :data="averagePeopleChart"
            header=""
            domId="peoplechart"
            title=""
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="adjust-view col-md-12 d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <span class="mr-3"
              ><img
                style="height: 47px; width: 47px"
                src="../../assets/PersonWalked.png"
                alt=""
            /></span>
            <span class="text-dak font-weight-600 s-24"
              >Service Attendance
            </span>
          </div>
          <div class="py-2 pl-4 primary--text s-15 bg-gray-500 fw-500">
            <el-dropdown trigger="click" class="w-100">
              <span class="el-dropdown-link w-100">
                <div
                  class="d-flex justify-content-between primary--text w-100"
                  size="large"
                >
                  <span class="my-2"
                    >Sort By
                    {{
                      selectedCurrYear && selectedCurrYear.name
                        ? selectedCurrYear.name
                        : selectedCurrYear
                    }}</span
                  >
                  <div class="bg-white d-flex py-1 my-1">
                    <el-icon class="el-icon--right">
                      <arrow-down />
                    </el-icon>
                  </div>
                </div>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    v-for="(itm, indx) in currentYearItem"
                    :key="indx"
                    @click="selectedType(itm)"
                    >{{ itm.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
        <div class="col-md-12 d-flex mt-3">
          <div
            v-for="(hierachy, index) in hierarchesData"
            :key="hierachy.id"
            class="s-16 fw-400 text-dak mr-2"
            :class="{
              'active-branch': activeAttendanceHierachyId === hierachy.id,
            }"
            @click="getAttendaceByHierarchy(hierachy)"
            style="cursor: pointer"
          >
            {{ hierachy.name }}
            <span v-if="index !== hierarchesData.length - 1"> &gt; </span>
          </div>
        </div>
        <div class="col-md-12 mt-4" v-loading="loading">
          <ColumnChart
            :series="attendanceSeries"
            :data="averageAttendanceChart"
            header=""
            domId="chart4"
            title=""
          />
        </div>
      </div>
    </div>

    <div
      class="no-person"
      v-if="!loading && !networkError && allBranchDetail.length === 0"
    >
      <div class="empty-img">
        <p><img src="../../assets/people/people-empty.svg" alt="" /></p>
        <p class="tip">You haven't added any Branch yet</p>
        <el-button
          round
          class="header-btn"
          @click="showModal"
          :color="primarycolor"
        >
          Add Branch
        </el-button>
      </div>
    </div>
    <div v-else-if="networkError && !loading" class="adjust-network">
      <img src="../../assets/network-disconnected.png" />
      <div>
        {{
          navigatorLang === "en-US"
            ? "Opps, Your internet connection was disrupted"
            : $t("people.internetConnectionDisrupted")
        }}
      </div>
    </div>
    <el-drawer
      v-model="showSMS"
      :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
      direction="rtl"
    >
      <template #header>
        <h4>Send SMS</h4>
      </template>
      <template #default>
        <div>
          <smsComponent @closesidemodal="() => (showSMS = false)" />
          <!-- <smsComponent :phoneNumbers="contacts" @closesidemodal="() => showSMS = false" /> -->
        </div>
      </template>
    </el-drawer>
    <el-drawer
      v-model="showEmail"
      :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
      direction="rtl"
    >
      <template #header>
        <h4>Send Email</h4>
      </template>
      <template #default>
        <div>
          <emailComponent @closesidemodal="() => (showEmail = false)" />
        </div>
      </template>
    </el-drawer>
    <el-drawer
      v-model="showWhatsapp"
      :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
      direction="rtl"
    >
      <template #default>
        <div>
          <whatSappComponent
            :allBranchDetail="allBranchDetail"
            @closesidemodal="() => (showWhatsapp = false)"
          />
        </div>
      </template>
    </el-drawer>
    <el-dialog
      class="border-radius-20"
      v-model="displayModal"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
      align-center
    >
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center">
          <div class="text-dak s-24 fw-500" v-if="hierarchies.length === 0">
            Click the button to setup
          </div>
          <div class="text-dak s-24 fw-500" v-else>
            Which of these option best suit your intentions?
          </div>
        </div>
        <div class="col-md-12 mt-4">
          <div class="row d-flex justify-content-center">
            <div
              class="col-md-6 d-flex flex-column align-items-center justify-content-center"
            >
              <div v-if="hierarchies.length === 0">
                <el-button
                  round
                  size="large"
                  @click="simpleBranch"
                  :color="primarycolor"
                  class="w-100 mb-3 py-4 text-center c-pointer"
                >
                  <span class="fw-400">Simple Branch Setup</span>
                </el-button>
                <el-button
                  round
                  size="large"
                  @click="hierarchicalBranchSetup"
                  class="w-100 border-black text-dak ml-0 py-4 mb-3 text-center c-pointer"
                >
                  <span class="fw-400"> Hierarchical Branch Network</span>
                </el-button>
              </div>
              <el-button
                v-else
                round
                size="large"
                :color="primarycolor"
                @click="hierarchicalBranch"
                class="w-100 border-black text-white py-4 mb-3 text-center c-pointer"
              >
                <span class="fw-400">Advance Branch Setup</span>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-model="displayHierarchiesModal"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
      align-center
      class="border-radius-20"
    >
      <div class="row">
        <div class="col-md-12">
          <HierarchiesSample />
        </div>
        <div class="col-md-12 d-flex justify-content-center">
          <div class="col-md-6">
            <el-button
              round
              size="large"
              class="mt-3 mb-3 w-100 primary-bg text-white text-center"
              @click="proceedToBranchHierachy"
            >
              Proceed
            </el-button>
          </div>
        </div>
      </div>
      <!-- <BranchSettings /> -->
    </el-dialog>
    <el-skeleton
      class="w-100"
      animated
      v-if="loading && allBranchDetail && allBranchDetail.length === 0"
    >
      <template #template>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;
          "
        >
          <el-skeleton-item
            variant="text"
            style="width: 240px; height: 240px"
          />
          <el-skeleton-item
            variant="text"
            style="width: 240px; height: 240px"
          />
        </div>
        <el-skeleton
          class="w-100 mt-5"
          style="height: 25px"
          :rows="20"
          animated
        />
      </template>
    </el-skeleton>
  </div>
</template>

<script>
import { ref, inject, onMounted, watch, computed, watchEffect } from "vue";
import axios from "@/gateway/backendapi";
import BranchIcon from "../../assets/ecommerce/branchIcon.png";
import router from "../../router";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import AnalysicIcon from "../../assets/ecommerce/analysicIcon.png";
import HierarchiesSample from "./component/HierarchiesSample.vue";
import ArrowUp from "../../assets/ecommerce/ArrowUp.png";
import ArrowDown from "../../assets/ecommerce/ArrowDown.png";
import WalkIcon from "../../assets/ecommerce/WalkIcon.png";
import LineChart from "@/components/charts/LineChart.vue";
import VideoPlayIcon from "../../components/svg/VideoPlayIcon.vue";
import ColumnChart from "@/components/charts/BranchColumnChart.vue";
import whatSappComponent from "../groups/component/whatSappComponent.vue";
import smsComponent from "../groups/component/smsComponent.vue";
import CustomTable from "@/components/table/CustomTable";
import emailComponent from "../groups/component/emailComponent.vue";
import finish from "../../services/progressbar/progress";
import { Search } from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import store from "../../store/store";
import { useStore } from "vuex";
import { socket } from "@/socket";
import swal from "sweetalert";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  components: {
    VideoPlayIcon,
    ColumnChart,
    LineChart,
    CustomTable,
    emailComponent,
    whatSappComponent,
    smsComponent,
    HierarchiesSample,
  },
  setup() {
    const displayModal = ref(false);
    // const startDate = ref("");
    // const endDate = ref("");
    const startDate = ref(new Date().setFullYear(new Date().getFullYear() - 1));
    const endDate = ref(new Date(Date.now()));
    const showSMS = ref(false);
    const showEmail = ref(false);
    const networkError = ref(false);
    const showWhatsapp = ref(false);
    const branchLoading = ref(false);
    const loading = ref(false);
    const firstTimerMonthlyAtt = ref(false);
    const firstTimerWeeklyAtt = ref(false);
    const sendWhatsappToMultiple = ref(false);
    const mainIncomeExpenseData = ref([]);
    const mainAverageAttData = ref([]);
    const hierarchies = ref([]);
    const displayHierarchiesModal = ref(false);
    const series = ref([]);
    const route = useRoute();
    const expenseData = ref([]);
    const selectedTree = ref(null);
    const incomeData = ref([]);
    const fullHierarchyData = ref([]);
    const data1 = ref({});
    const branchChartDetail = ref([]);
    const selectedBranchChartData = ref([]);
    const selectedIncomeExpenseChartData = ref([]);
    const searchText = ref("");
    const navigatorLang = ref(navigator.language);

    const videoURL = ref(
      "https://www.youtube.com/embed/JSI7IksFUNQ?si=updEhHP30u4H1Z40"
    );
    const showAddVideo = ref(false);
    const watchVideo = () => {
      showAddVideo.value = true;
    };
    const weekdays = ref([
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
    ]);
    const attendanceData = ref([
      {
        name: "Attendance",
        data: [12, 10, 8, 9, 7],
      },
    ]);
    const tenantInfo = ref({});
    const tenantInfoFirstTimerMonthly = ref([]);
    const averageAttData = ref([]);
    const firstTimerDataExist = ref(false);
    const sendingwhatsappmessage = ref(false);
    const groupedBranches = ref({});
    const groupedHierarchy = ref({});
    const mappedBranch = ref([]);
    const incomeExpenseCharrtData = ref([]);
    const incomeExpenseSeries = ref([]);
    const memberSeries = ref([]);
    const attendanceSeries = ref([]);
    const branchMappedTree = ref([]);
    const hierarchesData = ref([]);
    const flattenedTree = ref([]);
    const incomeExpenseWithHierachyData = ref([]);
    const averageAttendanceWithHierachyData = ref([]);
    const membersWithHierachyData = ref([]);
    const dataStore = useStore();
    const xAxis = ref([]);
    const allBranchDetail = ref([]);
    const selectedWeekly = ref("Year");
    const selectedCurrYear = ref("Current Year");
    // const allBranchDetail = ref(
    //   dataStore.getters["branch/getbranches"].branches
    // );
    const branchesWithHierarchy = ref([]);
    // const branchesWithHierarchy = ref(
    //   dataStore.getters["branch/getbranches"].branchesWithHierarchy
    // );
    // const allBranchDetail = ref([]);
    const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
    const activeMemberHierachyId = ref("");
    const activeIncomeExpenseHierarchyId = ref("");
    const activeAttendanceHierachyId = ref("");
    const monthXaxis = ref([
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ]);

    const branchHeaders = ref([
      { name: "", value: "name" },
      { name: "MEMBERS", value: "membershipSize" },
      { name: "AVG.ATTENDANCE.", value: "currentYearAverageAttendance" },
      { name: "INCOME", value: "currentYearIncome" },
      { name: "EXPENSE", value: "currentYearExpense" },
      // { name: "ACTION", value: "action" },
    ]);
    const sortOption = ref(""); // Add this line

    const sendMarkedMemberSms = () => {
      showSMS.value = true;
    };
    const sendMarkedBranchEmail = () => {
      showEmail.value = true;
    };
    const routeToReport = () => {
      router.push("/tenant/reports");
    };

    // Watch for changes in the sortOption to trigger sorting
    watch(sortOption, (newSortOption) => {
      sortBranches(newSortOption);
    });

    const currentMonth = ref("");

    // Function to get the current month
    const getCurrentMonth = () => {
      const date = new Date();
      // Get the month as a string (e.g., January, February)
      const month = date.toLocaleString("default", { month: "long" });
      currentMonth.value = month;
    };

    // Call the function when the component is mounted
    onMounted(() => {
      getCurrentMonth();
    });
    const proceedToBranchHierachy = () => {
      displayModal.value = false;
      router.push("/tenant/branch/initialhierachysetup");
    };

    const hierarchicalBranch = () => {
      // if (hierarchies.value.length === 0) {
      //   displayHierarchiesModal.value = true;
      // } else {
      displayModal.value = false;
      router.push("/tenant/branch/addbranch");
      // }
    };
    const hierarchicalBranchSetup = () => {
      displayHierarchiesModal.value = true;
      displayModal.value = false;
    };

    const getHierarchies = async () => {
      try {
        let { data } = await axios.get("/api/Branching/Hierarchies");

        hierarchies.value = data.returnObject;
        hierarchesData.value = data.returnObject.filter((i) => i.level !== 0);
        activeMemberHierachyId.value = hierarchesData.value[0]
          ? hierarchesData.value[0].id
          : "";
        activeIncomeExpenseHierarchyId.value = hierarchesData.value[0]
          ? hierarchesData.value[0].id
          : "";
        activeAttendanceHierachyId.value = hierarchesData.value[0]
          ? hierarchesData.value[0].id
          : "";

        // const firstHierarchy = hierarchesData.value[0];

        // 👇 Call this to load chart data for first hierarchy
        if (
          hierarchesData.value &&
          hierarchesData.value[0] &&
          branchesWithHierarchy.value
        ) {
          getTenantsSetsByHierarchy(
            hierarchesData.value[0].id,
            branchesWithHierarchy.value // Use full data
          );
        }
      } catch (err) {
        console.log(err);
      }
    };
    getHierarchies();

    // Define the sorting function
    const sortBranches = (criteria) => {
      // Implement sorting logic based on the criteria
      filteredGroups.value.sort((a, b) => {
        switch (criteria) {
          case "Branch Name":
            return a.name.localeCompare(b.name);
          case "Membership size":
            return a.membershipSize - b.membershipSize;
          case "Attendance":
            return (
              a.currentYearAverageAttendance - b.currentYearAverageAttendance
            );
          case "Income":
            return a.currentYearIncome - b.currentYearIncome;
          case "Expense":
            return a.currentYearExpense - b.currentYearExpense;
          default:
            return 0;
        }
      });
    };
    watchEffect(() => {
      socket.on("messagesent", (data) => {
        console.log(data, "status");

        swal(" Success", "Whatsapp message sent successfully!", "success");
        showWhatsapp.value = false;
        sendingwhatsappmessage.value = false;
      });
    });
    const displayWhatsappDrawer = (item) => {
      showWhatsapp.value = true;
      if (item) {
        sendWhatsappToMultiple.value = false;
      } else {
        sendWhatsappToMultiple.value = true;
      }
    };

    const primarycolor = inject("primarycolor");
    const showModal = () => {
      displayModal.value = true;
    };
    const chartItemdropdown = ref([
      { name: "Year", id: 1 },
      // { name: "Month", id: 1 },
      // { name: "Week", id: 2 },
    ]);
    const currentYearItem = ref([
      { name: "Current Year", id: 1 },
      // { name: "Week", id: 2 },
    ]);
    const tenantId = ref(
      store.getters.currentUser && store.getters.currentUser.tenantId
        ? store.getters.currentUser.tenantId
        : 0
    );
    const series2 = computed(() => {
      if (firstTimerWeeklyAtt.value === true) return xAxis.value;
      return monthXaxis.value;
    });
    onMounted(() => {
      for (let i = 1; i <= 52; i++) {
        xAxis.value.push(i);
      }
      if (selectedWeekly.value === "Monthly") {
        firstTimerMonthlyAtt.value = true;
        getBranchTenantDashboard();
      }
    });
    const getCurrentlySignedInUser = async () => {
      try {
        const res = await axios.get("/api/Membership/GetCurrentSignedInUser");
        tenantId.value = res.data.tenantId;
        console.log(tenantId.value, "hhgh");
      } catch (err) {
        /*eslint no-undef: "warn"*/
        console.log(err);
      }
    };
    getCurrentlySignedInUser();

    const viewBranch = (item) => {
      localStorage.setItem("branchId", item.id);
      localStorage.setItem("branchItem", JSON.stringify(item));
      router.push("/tenant/branches/summary");
    };

    const simpleBranch = () => {
      router.push("/tenant/branch/simplebranch");
    };
    // const hierarchicalBranch = () => {
    //   router.push("/tenant/branch/hierarchicalbranch");
    // };

    const selectedType2 = (item) => {
      selectedWeekly.value = item;
    };
    const selectedType = (item) => {
      selectedCurrYear.value = item;
    };
    const buildTreeAndFlatten = (data) => {
      const tree = [];
      const flat = [];

      const map = new Map();
      data.forEach((item) => {
        const node = {
          id: item.id,
          value: item.id, // for v-model binding
          label: item.name,
          parentID: item.parentID,
          children: [],
        };
        map.set(item.id, node);
        flat.push({
          label: node.label,
          value: node.value,
          parentID: item.parentID,
          id: node.id,
        }); // for quick lookup
      });

      for (const node of map.values()) {
        if (
          !node.parentID ||
          node.parentID === "00000000-0000-0000-0000-000000000000"
        ) {
          tree.push(node);
        } else {
          const parent = map.get(node.parentID);
          if (parent) {
            parent.children.push(node);
          } else {
            tree.push(node); // orphan fallback
          }
        }
      }

      flattenedTree.value = flat;
      return tree;
    };
    const getHierarchy = async () => {
      try {
        const { data } = await axios.get(
          "/api/Branching/GetBranchesLeanInformation"
        );
        const list = data.returnObject || [];
        branchMappedTree.value = buildTreeAndFlatten(list);
      } catch (error) {
        console.log("Error loading hierarchy", error);
      }
    };
    getHierarchy();
    const setBranchValue = async () => {
      const response = flattenedTree.value.find(
        (i) => i.value == selectedTree.value
      );

      try {
        loading.value = true;

        const { data } = await axios.get(
          `/api/Branching/GetBranchesBasicInformationSearch?startDate=${new Date(
            startDate.value
          ).toLocaleDateString("en-US")}&endDate=${new Date(
            endDate.value
          ).toLocaleDateString("en-US")}&branchId=${response.id}`
        );

        const branches = data.returnObject.branches || [];
        const withHierarchy = data.returnObject.branchesWithHierarchy || [];
        const filteredHierarchy =
          data.returnObject && data.returnObject.hierarchies
            ? data.returnObject.hierarchies.filter((i) => i.level !== 0)
            : [];
        hierarchesData.value = filteredHierarchy;

        branchChartDetail.value = branches;
        allBranchDetail.value = branches;
        incomeExpenseCharrtData.value = withHierarchy;
        branchesWithHierarchy.value = withHierarchy;
        fullHierarchyData.value = withHierarchy;
        incomeExpenseWithHierachyData.value = withHierarchy; // ✅ ensure this is set!
        averageAttendanceWithHierachyData.value = withHierarchy; // ✅ ensure this is set!
        membersWithHierachyData.value = withHierarchy; // ✅ ensure this is set!
        if (
          hierarchesData.value &&
          hierarchesData.value[0] &&
          branchesWithHierarchy.value
        ) {
          const matchedHierarchy = hierarchies.value.find((h) =>
            h.tenants?.some((t) => t.id === response.id)
          );

          getTenantsSetsByHierarchy(
            matchedHierarchy.id,
            branchesWithHierarchy.value // Use full data
          );
        }

        // Grouping
        const grouped = {};
        for (const branch of allBranchDetail.value) {
          const groupKey = branch.parentNames || "Ungrouped";
          if (!grouped[groupKey]) grouped[groupKey] = [];
          grouped[groupKey].push(branch);
        }
        groupedBranches.value = grouped;
        const selectedLevel = response.level;
        const selectedId = response.id;

        const branchesAtSelectedLevel = flattenedTree.value.filter(
          (item) => item.level === selectedLevel && item.id === selectedId
        );

        const branchesAtNextLevel = flattenedTree.value.filter(
          (item) => item.parentID === selectedId
        );

        const limitedBranches = [
          ...branchesAtSelectedLevel,
          ...branchesAtNextLevel,
        ];
        console.log(
          "🎯 Selected level and immediate children:",
          limitedBranches
        );

        // branchesWithHierarchy.value = limitedBranches;

        if (
          response.parentID === "00000000-0000-0000-0000-000000000000" ||
          !response.parentID
        ) {
          getHierarchies();
        }

        loading.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
      }
    };

    const filterNodeMethod = (value, data) =>
      data.label.toLowerCase().includes(value.toLowerCase());

    const getBranches = async () => {
      loading.value = true;
      try {
        await store.dispatch("branch/getBranches").then((res) => {
          const branches = res.branches || [];
          const withHierarchy = res.branchesWithHierarchy || [];

          branchChartDetail.value = branches;
          allBranchDetail.value = branches;
          incomeExpenseCharrtData.value = withHierarchy;
          branchesWithHierarchy.value = withHierarchy;
          fullHierarchyData.value = withHierarchy;
          incomeExpenseWithHierachyData.value = withHierarchy; // ✅ ensure this is set!
          averageAttendanceWithHierachyData.value = withHierarchy; // ✅ ensure this is set!
          membersWithHierachyData.value = withHierarchy; // ✅ ensure this is set!
          if (branchesWithHierarchy.value) {
            getHierarchies();
          }
          // getAllSeries(withHierarchy);
          // getIncomeExpenseSeries(withHierarchy);
          // getMemberSeries(withHierarchy);
          // getAverageAttendanceSeries(withHierarchy);

          const grouped = {};
          for (const branch of allBranchDetail.value) {
            const groupKey = branch.parentNames || "Ungrouped";

            if (!grouped[groupKey]) {
              grouped[groupKey] = [];
            }

            grouped[groupKey].push(branch);
          }
          loading.value = false;

          groupedBranches.value = grouped;
          loading.value = false;
        });
      } catch (error) {
        finish();
        loading.value = false;
        networkError.value = true;
        if (error.toString().toLowerCase().includes("network error")) {
          networkError.value = true;
        } else {
          networkError.value = false;
        }
      }
    };

    const filteredGroups = computed(() => {
      if (!searchText.value.trim()) {
        return groupedBranches.value;
      }

      const lowerSearch = searchText.value.toLowerCase();

      const result = {};

      for (const [groupName, branches] of Object.entries(
        groupedBranches.value
      )) {
        const filtered = branches.filter((branch) =>
          branch.name.toLowerCase().includes(lowerSearch)
        );
        if (filtered.length > 0) {
          result[groupName] = filtered;
        }
      }

      return result;
    });

    const getAllSeries = () => {
      branchLoading.value = true;
      series.value = []; // reset it first

      if (
        branchesWithHierarchy.value &&
        Array.isArray(branchesWithHierarchy.value)
      ) {
        branchesWithHierarchy.value.forEach((i) => {
          if (i.name) {
            series.value.push(i.name); // keep correct order
          }
        });
      }

      branchLoading.value = false;
    };
    const getIncomeExpenseSeries = (data) => {
      branchLoading.value = true;
      incomeExpenseSeries.value = []; // reset it first

      if (data && Array.isArray(data)) {
        data.forEach((i) => {
          if (i.name) {
            incomeExpenseSeries.value.push(i.name); // keep correct order
          }
        });
      }

      branchLoading.value = false;
    };
    const getMemberSeries = (data) => {
      branchLoading.value = true;
      memberSeries.value = []; // reset it first

      if (data && Array.isArray(data)) {
        data.forEach((i) => {
          if (i.name) {
            memberSeries.value.push(i.name); // keep correct order
          }
        });
      }

      branchLoading.value = false;
    };
    const getAverageAttendanceSeries = (data) => {
      branchLoading.value = true;
      attendanceSeries.value = []; // reset it first

      if (data && Array.isArray(data)) {
        data.forEach((i) => {
          if (i.name) {
            attendanceSeries.value.push(i.name); // keep correct order
          }
        });
      }

      branchLoading.value = false;
    };
    const getBranchOverviewData = async () => {
      try {
        const { data } = await axios.get(
          "/api/Branching/GetBranchesBasicInformation"
        );

        const branches = data.returnObject.branches || [];
        const withHierarchy = data.returnObject.branchesWithHierarchy || [];

        branchChartDetail.value = branches;
        allBranchDetail.value = branches;
        incomeExpenseCharrtData.value = withHierarchy;
        branchesWithHierarchy.value = withHierarchy;
        fullHierarchyData.value = withHierarchy;
        incomeExpenseWithHierachyData.value = withHierarchy; // ✅ ensure this is set!
        averageAttendanceWithHierachyData.value = withHierarchy; // ✅ ensure this is set!
        membersWithHierachyData.value = withHierarchy; // ✅ ensure this is set!

        if (branchesWithHierarchy.value) {
          getHierarchies();
        }

        // getAllSeries(withHierarchy);
        // getIncomeExpenseSeries(withHierarchy);
        // getMemberSeries(withHierarchy);
        // getAverageAttendanceSeries(withHierarchy);
      } catch (error) {
        networkError.value = error
          .toString()
          .toLowerCase()
          .includes("network error");
        console.error("Fetch Error:", error);
      }
    };
    getBranchOverviewData();

    const showConfirmModal = (id, index) => {
      ElMessageBox.confirm(
        "Are you sure you want to proceed?",
        "Confirm delete",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(() => {
          deleteBranch(id, index);
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "Delete canceled",
            duration: 5000,
          });
        });
    };
    const deleteBranch = (id) => {
      axios
        .delete(`/api/Branching/${id}`)
        .then((res) => {
          console.log(res);
          ElMessage({
            type: "success",
            message: "Branch form deleted",
            duration: 5000,
          });
          allBranchDetail.value = allBranchDetail.value.filter(
            (branchlist) => branchlist.id !== id
          );
          // store.dispatch("pledge/removePledgeFromStore", id);
        })
        .catch((err) => {
          if (err.response.status === 400) {
            ElMessage({
              type: "error",
              message: "Unable to delete",
              duration: 5000,
            });
          } else {
            ElMessage({
              type: "error",
              message: "Unable to delete",
              duration: 5000,
            });
          }
        });
    };

    const incomeExpenseCharrt = computed(() => {
      const data = incomeExpenseWithHierachyData.value?.length
        ? incomeExpenseWithHierachyData.value
        : branchesWithHierarchy.value;

      if (!Array.isArray(data) || data.length === 0) return [];

      return [
        {
          name: "Income",
          color: "#005EFF",
          data: data.map((item) => Math.abs(item.currentYearIncome || 0)),
        },
        {
          name: "Expense",
          color: "#08A53D",
          data: data.map((item) => Math.abs(item.currentYearExpense || 0)),
        },
      ];
    });

    const averageAttendanceChart = computed(() => {
      const data = averageAttendanceWithHierachyData.value?.length
        ? averageAttendanceWithHierachyData.value
        : branchesWithHierarchy.value;

      if (!Array.isArray(data) || data.length === 0) return [];

      const currentYearAttendanceData = [];
      data.forEach((item) => {
        currentYearAttendanceData.push(
          Math.abs(item.currentYearAverageAttendance)
        );
      });

      return [
        {
          name: "Attendance",
          color: "#005EFF",
          data: currentYearAttendanceData,
        },
      ];
    });
    const averagePeopleChart = computed(() => {
      const data = membersWithHierachyData.value?.length
        ? membersWithHierachyData.value
        : branchesWithHierarchy.value;
      const currentYearPeopleeData = [];
      data.forEach((item) => {
        currentYearPeopleeData.push(Math.abs(item.membershipSize));
      });

      // Return the transformed data
      return [
        {
          name: "Membership",
          color: "#096474",
          data: currentYearPeopleeData,
        },
      ];
    });

    const getTotalPeopleBch = computed(() => {
      if (allBranchDetail.value && allBranchDetail.value.length > 0) {
        return allBranchDetail.value
          .map((i) => i.membershipSize)
          .reduce((b, a) => b + a, 0);
      } else {
        return 0;
      }
    });
    const getTotalMonthlyInflow = computed(() => {
      if (allBranchDetail.value && allBranchDetail.value.length > 0) {
        return allBranchDetail.value
          .map((i) => i.currentMonthIncome)
          .reduce((b, a) => b + a, 0);
      } else {
        return 0;
      }
    });
    const getTotalAverageAttendance = computed(() => {
      if (allBranchDetail.value && allBranchDetail.value.length > 0) {
        return allBranchDetail.value
          .map((i) => i.currentYearAverageAttendance)
          .reduce((b, a) => b + a, 0);
      } else {
        return 0;
      }
    });
    const getTotalMonthlyOutflow = computed(() => {
      if (allBranchDetail.value && allBranchDetail.value.length > 0) {
        return allBranchDetail.value
          .map((i) => i.currentMonthExpense)
          .reduce((b, a) => b + a, 0);
      } else {
        return 0;
      }
    });
    const getCurrentYearInflow = computed(() => {
      if (allBranchDetail.value && allBranchDetail.value.length > 0) {
        return allBranchDetail.value
          .map((i) => i.currentYearIncome)
          .reduce((b, a) => b + a, 0);
      } else {
        return 0;
      }
    });
    const getCurrentYearOutflow = computed(() => {
      if (allBranchDetail.value && allBranchDetail.value.length > 0) {
        return allBranchDetail.value
          .map((i) => i.currentYearExpense)
          .reduce((b, a) => b + a, 0);
      } else {
        return 0;
      }
    });
    const lastMonthIncomeSum = computed(() => {
      return allBranchDetail.value.reduce((sum, item) => {
        return sum + (item.lastMonthIncome || 0);
      }, 0);
    });
    const lastMonthExpenseSum = computed(() => {
      return allBranchDetail.value.reduce((sum, item) => {
        return sum + (item.lastMonthExpense || 0);
      }, 0);
    });
    const expensePercentage = computed(() => {
      return lastMonthExpenseSum.value === 0
        ? 0
        : (getTotalMonthlyOutflow.value / lastMonthExpenseSum.value) * 100;
    });

    const incomePercentage = computed(() => {
      return lastMonthIncomeSum.value === 0
        ? 0
        : (getTotalMonthlyInflow.value / lastMonthIncomeSum.value) * 100;
    });

    const searchBranchDetail = computed(() => {
      if (searchText.value !== "" && allBranchDetail.value.length > 0) {
        return allBranchDetail.value.filter((i) => {
          if (i.name)
            return i.name
              .toLowerCase()
              .includes(searchText.value.toLowerCase());
        });
      } else {
        return allBranchDetail.value;
      }
    });
    const getBranchTenantDashboard = async () => {
      branchLoading.value = true;
      try {
        const { data } = await axios.get(
          `/DashboardForTenant?_TenantId=${tenantId.value}`
        );
        tenantInfo.value = data;
        tenantInfoFirstTimerMonthly.value =
          data.firstTimerSummary.firstTimerMonthly;

        tenantInfoFirstTimerMonthly.value[0].data.forEach((element) => {
          if (element > 0) {
            firstTimerDataExist.value = true;
          }
        });
        branchLoading.value = false;
      } catch (error) {
        if (error.toString().toLowerCase().includes("network error")) {
          networkError.value = true;
        } else {
          networkError.value = false;
        }
        branchLoading.value = false;
      }
    };
    getBranchTenantDashboard();

    const monthlyFirstTimerObj = computed(() => {
      if (!tenantInfoFirstTimerMonthly.value) return [];
      return tenantInfoFirstTimerMonthly.value;
    });

    // const getAllTenantByHierarchy = async (hierachy) => {
    //   await nextTick();
    //   const hierachyData = fullHierarchyData.value;

    //   getTenantsSetsByHierarchy(hierachy.id, hierachyData);
    // };

    const getIncomeExpenseByHierarchy = async (hierachy) => {
      activeIncomeExpenseHierarchyId.value = hierachy.id;
      const hierachyData = fullHierarchyData.value;

      getIncomeExpensSetsByHierarchy(hierachy.id, hierachyData);
    };
    const getMembersByHierarchy = async (hierachy) => {
      activeMemberHierachyId.value = hierachy.id;
      const hierachyData = fullHierarchyData.value;

      getMembersSetsByHierarchy(hierachy.id, hierachyData);
    };
    const getAttendaceByHierarchy = async (hierachy) => {
      activeAttendanceHierachyId.value = hierachy.id;
      const hierachyData = fullHierarchyData.value;

      getAttendanceSetByHierarchy(hierachy.id, hierachyData);
    };

    const getTenantsSetsByHierarchy = (hierarchyID, allTenants) => {
      const tenantSets = [];

      // These are the numeric fields you want to summarize (sum) across all tenants in a set
      const sumFields = [
        "membershipSize",
        "firstTimerCount",
        "currentYearAverageAttendance",
        "currentYearAverageIncome",
        "currentYearAverageExpense",
        "currentYearIncome",
        "currentYearExpense",
        "currentMonthExpense",
        "lastMonthExpense",
        "lastMonthIncome",
        "currentMonthIncome",
      ];

      // Recursively traverse and collect all descendants of a given tenant
      function traverseTenantAndChildren(tenant, set) {
        set.push(tenant); // Add current tenant
        const children = allTenants.filter((t) => t.parentID === tenant.id);
        for (const child of children) {
          traverseTenantAndChildren(child, set); // Recursively add children
        }
      }

      // Step 1: Find all root tenants that match the given hierarchy ID
      const rootTenants = allTenants.filter(
        (t) => t.hierarchyID === hierarchyID
      );

      // Step 2: For each root tenant, collect its full tenant "set"
      for (const root of rootTenants) {
        const set = [];
        traverseTenantAndChildren(root, set); // Collect root + children recursively

        // Step 3: Calculate totals for numeric fields
        const totals = {};
        for (const field of sumFields) {
          totals[field] = set.reduce((sum, tenant) => {
            const value = Number(tenant[field]) || 0; // Coerce to number and handle undefined
            return sum + value;
          }, 0);
        }

        // Step 4: Push the final object into tenantSets
        tenantSets.push({
          name: root ? root.name : "", // The root tenant's name
          members: set, // All tenants under this root (including itself)
          ...totals, // Spread the calculated totals as top-level keys
        });
      }

      // Final list of sets

      incomeExpenseWithHierachyData.value = tenantSets;
      averageAttendanceWithHierachyData.value = tenantSets;
      membersWithHierachyData.value = tenantSets;
      getAverageAttendanceSeries(tenantSets);
      getMemberSeries(tenantSets);
      getIncomeExpenseSeries(tenantSets);
      console.log(tenantSets, "henery");
    };
    function getIncomeExpensSetsByHierarchy(hierarchyID, allTenants) {
      const tenantSets = [];

      // These are the numeric fields you want to summarize (sum) across all tenants in a set
      const sumFields = [
        "membershipSize",
        "firstTimerCount",
        "currentYearAverageAttendance",
        "currentYearAverageIncome",
        "currentYearAverageExpense",
        "currentYearIncome",
        "currentYearExpense",
        "currentMonthExpense",
        "lastMonthExpense",
        "lastMonthIncome",
        "currentMonthIncome",
      ];

      // Recursively traverse and collect all descendants of a given tenant
      function traverseTenantAndChildren(tenant, set) {
        set.push(tenant); // Add current tenant
        const children = allTenants.filter((t) => t.parentID === tenant.id);
        for (const child of children) {
          traverseTenantAndChildren(child, set); // Recursively add children
        }
      }

      // Step 1: Find all root tenants that match the given hierarchy ID
      const rootTenants = allTenants.filter(
        (t) => t.hierarchyID === hierarchyID
      );

      // Step 2: For each root tenant, collect its full tenant "set"
      for (const root of rootTenants) {
        const set = [];
        traverseTenantAndChildren(root, set); // Collect root + children recursively

        // Step 3: Calculate totals for numeric fields
        const totals = {};
        for (const field of sumFields) {
          totals[field] = set.reduce((sum, tenant) => {
            const value = Number(tenant[field]) || 0; // Coerce to number and handle undefined
            return sum + value;
          }, 0);
        }

        // Step 4: Push the final object into tenantSets
        tenantSets.push({
          name: root ? root.name : "", // The root tenant's name
          members: set, // All tenants under this root (including itself)
          ...totals, // Spread the calculated totals as top-level keys
        });
      }

      // Final list of sets
      incomeExpenseWithHierachyData.value = tenantSets;
      console.log(tenantSets, "tenantSets");
      getIncomeExpenseSeries(tenantSets);
    }
    function getMembersSetsByHierarchy(hierarchyID, allTenants) {
      const tenantSets = [];

      // These are the numeric fields you want to summarize (sum) across all tenants in a set
      const sumFields = [
        "membershipSize",
        "firstTimerCount",
        "currentYearAverageAttendance",
        "currentYearAverageIncome",
        "currentYearAverageExpense",
        "currentYearIncome",
        "currentYearExpense",
        "currentMonthExpense",
        "lastMonthExpense",
        "lastMonthIncome",
        "currentMonthIncome",
      ];

      // Recursively traverse and collect all descendants of a given tenant
      function traverseTenantAndChildren(tenant, set) {
        set.push(tenant); // Add current tenant
        const children = allTenants.filter((t) => t.parentID === tenant.id);
        for (const child of children) {
          traverseTenantAndChildren(child, set); // Recursively add children
        }
      }

      // Step 1: Find all root tenants that match the given hierarchy ID
      const rootTenants = allTenants.filter(
        (t) => t.hierarchyID === hierarchyID
      );

      // Step 2: For each root tenant, collect its full tenant "set"
      for (const root of rootTenants) {
        const set = [];
        traverseTenantAndChildren(root, set); // Collect root + children recursively

        // Step 3: Calculate totals for numeric fields
        const totals = {};
        for (const field of sumFields) {
          totals[field] = set.reduce((sum, tenant) => {
            const value = Number(tenant[field]) || 0; // Coerce to number and handle undefined
            return sum + value;
          }, 0);
        }

        // Step 4: Push the final object into tenantSets
        tenantSets.push({
          name: root ? root.name : "", // The root tenant's name
          members: set, // All tenants under this root (including itself)
          ...totals, // Spread the calculated totals as top-level keys
        });
      }

      // Final list of sets
      membersWithHierachyData.value = tenantSets;
      getMemberSeries(tenantSets);
    }
    function getAttendanceSetByHierarchy(hierarchyID, allTenants) {
      const tenantSets = [];

      // These are the numeric fields you want to summarize (sum) across all tenants in a set
      const sumFields = [
        "membershipSize",
        "firstTimerCount",
        "currentYearAverageAttendance",
        "currentYearAverageIncome",
        "currentYearAverageExpense",
        "currentYearIncome",
        "currentYearExpense",
        "currentMonthExpense",
        "lastMonthExpense",
        "lastMonthIncome",
        "currentMonthIncome",
      ];

      // Recursively traverse and collect all descendants of a given tenant
      function traverseTenantAndChildren(tenant, set) {
        set.push(tenant); // Add current tenant
        const children = allTenants.filter((t) => t.parentID === tenant.id);
        for (const child of children) {
          traverseTenantAndChildren(child, set); // Recursively add children
        }
      }

      // Step 1: Find all root tenants that match the given hierarchy ID
      const rootTenants = allTenants.filter(
        (t) => t.hierarchyID === hierarchyID
      );

      // Step 2: For each root tenant, collect its full tenant "set"
      for (const root of rootTenants) {
        const set = [];
        traverseTenantAndChildren(root, set); // Collect root + children recursively

        // Step 3: Calculate totals for numeric fields
        const totals = {};
        for (const field of sumFields) {
          totals[field] = set.reduce((sum, tenant) => {
            const value = Number(tenant[field]) || 0; // Coerce to number and handle undefined
            return sum + value;
          }, 0);
        }

        // Step 4: Push the final object into tenantSets
        tenantSets.push({
          name: root ? root.name : "", // The root tenant's name
          members: set, // All tenants under this root (including itself)
          ...totals, // Spread the calculated totals as top-level keys
        });
      }

      // Final list of sets
      averageAttendanceWithHierachyData.value = tenantSets;
      console.log(tenantSets, "tenantSets");
      getAverageAttendanceSeries(tenantSets);
    }

    onMounted(() => {
      if (
        !allBranchDetail.value ||
        (allBranchDetail.value && allBranchDetail.value.length == 0)
      )
        getBranches();

      const grouped = {};
      for (const branch of allBranchDetail.value) {
        const groupKey = branch.parentNames || "Ungrouped";

        if (!grouped[groupKey]) {
          grouped[groupKey] = [];
        }

        grouped[groupKey].push(branch);
      }

      groupedBranches.value = grouped;
    });

    return {
      incomeExpenseSeries,
      memberSeries,
      attendanceSeries,
      incomeExpenseWithHierachyData,
      averageAttendanceWithHierachyData,
      membersWithHierachyData,
      fullHierarchyData,
      branchesWithHierarchy,
      selectedBranchChartData,
      selectedIncomeExpenseChartData,
      getIncomeExpenseByHierarchy,
      getMembersByHierarchy,
      getAttendaceByHierarchy,
      activeMemberHierachyId,
      activeIncomeExpenseHierarchyId,
      activeAttendanceHierachyId,
      startDate,
      endDate,
      hierarchesData,
      routeToReport,
      averagePeopleChart,
      groupedBranches,
      groupedHierarchy,
      filteredGroups,
      // groupHeaders,
      flattenedTree,
      selectedTree,
      branchMappedTree,
      setBranchValue,
      filterNodeMethod,
      hierarchicalBranchSetup,
      navigatorLang,
      showAddVideo,
      watchVideo,
      tenantInfo,
      mappedBranch,
      viewBranch,
      incomeExpenseCharrtData,
      expensePercentage,
      incomePercentage,
      incomeExpenseCharrt,
      mainIncomeExpenseData,
      lastMonthIncomeSum,
      lastMonthExpenseSum,
      selectedWeekly,
      tenantId,
      getTotalPeopleBch,
      allBranchDetail,
      route,
      branchHeaders,
      networkError,
      displayModal,
      branchLoading,
      loading,
      primarycolor,
      BranchIcon,
      ArrowUp,
      ArrowDown,
      WalkIcon,
      AnalysicIcon,
      firstTimerWeeklyAtt,
      sendWhatsappToMultiple,
      displayHierarchiesModal,
      mainAverageAttData,
      averageAttData,
      showModal,
      hierarchies,
      displayWhatsappDrawer,
      firstTimerDataExist,
      monthlyFirstTimerObj,
      searchText,
      searchBranchDetail,
      tenantInfoFirstTimerMonthly,
      firstTimerMonthlyAtt,
      currentMonth,
      Search,
      series2,
      monthXaxis,
      xAxis,
      chartItemdropdown,
      selectedType2,
      selectedType,
      simpleBranch,
      hierarchicalBranch,
      showConfirmModal,
      proceedToBranchHierachy,
      series,
      currentYearItem,
      mdAndUp,
      selectedCurrYear,
      lgAndUp,
      xlAndUp,
      xsOnly,
      data1,
      attendanceData,
      getTotalMonthlyInflow,
      getTotalMonthlyOutflow,
      getCurrentYearInflow,
      getCurrentYearOutflow,
      getTotalAverageAttendance,
      weekdays,
      showEmail,
      showSMS,
      showWhatsapp,
      sendingwhatsappmessage,
      incomeData,
      expenseData,
      averageAttendanceChart,
      branchChartDetail,
      sendMarkedMemberSms,
      sendMarkedBranchEmail,
    };
  },
};
</script>

<style>
.active-branch {
  color: #136acd !important; /* Blue */
  /* text-decoration: underline; */
  font-weight: 600 !important;
}
.branchesHeight {
  height: 581px !important;
  overflow-y: scroll !important;
}
.card-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}
.card-icon {
  font-size: 18px;
}
.inflow {
  transform: rotate(180deg);
}
.outflow {
  transform: rotate(-180deg);
}
.card-text {
  margin: 0;
  font-size: 14px;
  color: #555555;
}
.card-title {
  font-size: 20px;
  margin: 0;
}
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table th,
.table td {
  vertical-align: middle;
  justify-content: center;
  padding: 1rem 3rem;
}

.table thead th {
  border-bottom: 2px solid #dee2e6;
  color: #787878;
  font-weight: 600 !important;
  border: none;
}
/* .adjust-view {
  position: relative;
  top: 35px;
  right: 10px;
  z-index: 1;
} */

.table tbody tr:hover {
  background-color: #f1f1f1;
}
.empty-img {
  width: 85%;
  margin: auto;
}

.empty-img img {
  width: 100%;
  max-width: 200px;
}
.no-person {
  height: 80vh;
  display: flex;
  text-align: center;
}
</style>
